export const unfilledRecoveryPrebidBehaviours = [
  'disabled',
  'cached',
  'runRecoveryPrebidAuction',
] as const

export type UnfilledRecoveryPrebidBehaviour = (typeof unfilledRecoveryPrebidBehaviours)[number]
